const textFieldFormEquip = {
  serialNumber: 'Serial number',
  brand: 'Equipment Brand',
  name: 'Equipment Specifications',
  reference: 'Reference point',
  amount: 'Amount',
  acquisitionDate: 'Acquisition Date',
  residualValue: 'Residual Value',
};

export default textFieldFormEquip;

